export default {
  namespaced: true,
  state: {
    sequenceNumber: 0,
    forms: {},
    flattenedForm: {}
  },
  actions: {
    register({ commit, state }) {
      commit('INCREASE_SEQUENCE_NUMBER');
      const editorNumber = state.sequenceNumber;
      return editorNumber;
    },
    unregister({ commit }, editorNumber) {
      commit('DELETE_FORM', editorNumber);
      commit('UPDATE_FLATTENED_FORM');
    },
    update({ commit }, { form, editorNumber }) {
      commit('UPDATE_FORM', { form, sequenceNumber: editorNumber });
      commit('UPDATE_FLATTENED_FORM');
    },
    clearForms({ commit }) {
      return commit('CLEAR_FORMS');
    }
  },
  getters: {
    form: state => state.form,
    flattenedForm: state => state.flattenedForm,
    value: state => field => {
      const value = state.flattenedForm[field];
      return value;
    }
  },
  mutations: {
    INCREASE_SEQUENCE_NUMBER: state => {
      state.sequenceNumber++;
    },
    DELETE_FORM: (state, sequenceNumber) => {
      delete state.forms[sequenceNumber];
    },
    UPDATE_FLATTENED_FORM: state => {
      state.flattenedForm = Object.keys(state.forms).reduce(
        (flattened, key) => ({ ...flattened, ...state.forms[key] }),
        {}
      );
    },
    UPDATE_FORM: (state, { sequenceNumber, form }) => {
      state.forms[sequenceNumber] = form;
    },
    CLEAR_FORMS: state => {
      state.forms = {};
      state.flattenedForm = {};
      state.sequenceNumber = 0;
    }
  }
};
